export default{
    lang:"th",
    fontFamily:"th-font-family",
    fontFamilyTitle:"th-font-family-title",
    requestLang:"th_TH",
    type: "en",
}